<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="paper-plane"/> Projecties
    </div>
    <div class="card-graph">
      <GChart
        :settings="{ packages: ['corechart'], language: 'nl-nl' }"
        :data="rows"
        :options="options"
        :events="chartEvents"
        type="ComboChart"
      />
    </div>
    <div id="project-tooltip"></div>
  </div>
</template>

<script>
export default {
  name: 'ProjectWidget',
  data() {
    return {
      options: {
        tooltip: {
          trigger: 'none',
        },
        backgroundColor: { fill: 'transparent' },
        height: 300,
        colors: JSON.parse(JSON.stringify(this.$store.state.colorScheme)),
        legend: { position: 'none' },
        pointSize: 0,
        chartArea: {
          left: 65,
          top: 25,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          format: 'yyyy',
          textStyle: { fontSize: 13 },
          gridlines: { color: '#eee' },
        },
        vAxis: {
          // format: '\'€\' ',
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        series: {
          0: {
            type: 'line',
            color: '#67bf00',
          },
          1: {
            type: 'line',
            color: '#000066',
            annotations: {
              stem: {
                color: 'green',
              },
              textStyle: {
                color: 'black',
                auraColor: '#fff',
              },
              stemLength: 30,
            },
          },
          2: {
            type: 'line', color: '#c1272d',
          },
          3: {
            type: 'line', areaOpacity: 0, color: 'green', lineWidth: 1,
          },
        },
        annotations: {
          stem: {
            color: 'black',
          },
          stemLength: 200,
        },
      },
      chartEvents: {
        onmouseover: this.setTooltipContent,
        onmouseout: () => { this.setTooltipContent(null); },
      },
    };
  },
  computed: {
    rows() {
      return [this.getCols()].concat(this.getRows());
    },
    currentPort() {
      return this.$parent.currentPort;
    },
  },
  methods: {
    getCols() {
      const cols = [
        {
          type: 'date',
          label: 'Datum',
        }, {
          type: 'string',
          role: 'annotation',
        }, {
          type: 'number',
          label: 'Goed',
        }, {
          type: 'number',
          label: 'Normaal',
        }, {
          type: 'string',
          role: 'annotation',
        }, {
          type: 'number',
          label: 'Slecht',
        },
      ];
      if (this.currentPort.target !== 0) {
        cols.push({
          type: 'number',
          label: 'Doelwaarde',
        });
      }
      return cols;
    },
    getRows() {
      let targetDate = false;
      let goalDate = false;
      const rows = [];
      const pvvidata = JSON.parse(this.currentPort.sat.raw || '[]');
      if (pvvidata.length > 0) {
        this.options.hAxis.ticks = [];
        const datesArray = [];
        for (let i = 0; i < pvvidata.length; i += 1) {
          const iDate = pvvidata[i].Date.split('-')[0];
          if (i === 0) {
            datesArray.push(new Date(pvvidata[i].Date));
          } else if (datesArray[datesArray.length - 1].getFullYear() !== Number(iDate)) {
            datesArray.push(new Date(iDate, 0, 1));
          }
        }
        this.options.hAxis.ticks = datesArray;
      }
      if (pvvidata && Object.keys(pvvidata).length !== 0) {
        let good = true;
        let normal = true;
        let bad = true;
        for (let key = 0; key < pvvidata.length; key += 1) {
          const satDate = new Date(pvvidata[key].DateJS);
          let rowItem;
          if (good && pvvidata[key].vG <= 0) {
            pvvidata[key].vG = 0;
            good = false;
          } else if (pvvidata[key].vG <= 0) {
            pvvidata[key].vG = null;
          }
          if (normal && pvvidata[key].vN <= 0) {
            pvvidata[key].vN = 0;
            normal = false;
          } else if (pvvidata[key].vN <= 0) {
            pvvidata[key].vN = null;
          }
          if (bad && pvvidata[key].vB <= 0) {
            pvvidata[key].vB = 0;
            bad = false;
          } else if (pvvidata[key].vB <= 0) {
            pvvidata[key].vB = null;
          }

          if (!targetDate && satDate > new Date(this.currentPort.target_date)) {
            targetDate = true;
            rowItem = [
              satDate,
              'Doeldatum',
              pvvidata[key].vG,
              pvvidata[key].vN,
              null,
              pvvidata[key].vB,
            ];
          } else if (
            !goalDate
            && this.currentPort.target > 0
            && pvvidata[key].vN > this.currentPort.target
          ) {
            goalDate = true;
            rowItem = [
              satDate,
              null,
              pvvidata[key].vG,
              pvvidata[key].vN,
              'Doel bereikt',
              pvvidata[key].vB,
            ];
          } else {
            rowItem = [
              satDate,
              null,
              pvvidata[key].vG,
              pvvidata[key].vN,
              null,
              pvvidata[key].vB,
            ];
          }

          if (this.currentPort.target !== 0) {
            rowItem.push(this.currentPort.target);
          }
          rows.push(rowItem);
        }
      }
      return rows;
    },
    setTooltipContent(object) {
      const tooltip = document.getElementById('project-tooltip');
      const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
      if (object !== null) {
        let label = '';
        let value = '';
        if (this.rows[0][object.column].label !== undefined) {
          label = ` ${this.rows[0][object.column].label}: `;
          value = `<b>&euro;&nbsp;${this.formatPrice(this.rows[object.row + 1][object.column], true)},-</b>`;
        }
        tooltip.style.display = 'block';
        tooltip.innerHTML = `<b>${this.rows[object.row + 1][0].toLocaleString('nl-NL', dateOptions)}</b>${label}${value}`;
      } else {
        tooltip.style.display = 'none';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .card-graph {
    padding-bottom: 10px;
    min-height: 300px;
  }
  #project-tooltip {
    padding: 10px 20px;
    background-color: #fcf8e3;
    color: #8a6d3b;
    display: block;
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    display: none;
    pointer-events: none;
    border-radius: $br;
  }
</style>
